import { RBItem } from "@/interfaces/CardItem";

import _ from "lodash";
import { IFiltersRB } from "@/components/DeckBuilder/game/riftbound/filters/getDefaultFilters";
import { getCardData } from "@/lib/games/riftbound/getCardDataLocal";

export function filterCards(
  baseSortedCards: RBItem[],
  filters: IFiltersRB,
  defaultFilters: IFiltersRB,
  deckCardsMap: any,
): RBItem[] {
  let filteredCards: RBItem[] = [];

  if (_.isEqual(filters, defaultFilters)) {
    return baseSortedCards;
  }

  for (const card of baseSortedCards) {
    let shouldAdd = true;

    // Name filter
    if (filters.search !== "") {
      if (shouldAdd) {
        if (filters.searchSelect.has("name")) {
          // search only in name. Need to improve this further like magic's system
          shouldAdd = card.name
            .toLowerCase()
            .includes(filters.search.toLowerCase());
        } else if (filters.searchSelect.has("effect")) {
          shouldAdd = card.effect
            .toLowerCase()
            .includes(filters.search.toLowerCase());
        } else if (filters.searchSelect.has("type")) {
          shouldAdd =
            shouldAdd &&
            card.tags
              .join(" ")
              .toLowerCase()
              .includes(filters.search.toLowerCase());
        } else {
          // check everything
          shouldAdd =
            card.name.toLowerCase().includes(filters.search.toLowerCase()) ||
            card.effect.toLowerCase().includes(filters.search.toLowerCase()) ||
            card.card_type
              .toLowerCase()
              .includes(filters.search.toLowerCase()) ||
            card.id.toLowerCase().includes(filters.search.toLowerCase());
        }
      }
    }

    // Color filter
    if (filters.color.size !== 0) {
      const colorsToSearch = Array.from(filters.color);
      const curColors = card.color
        .split("/")
        .map((element: string) => element.toLowerCase());
      shouldAdd =
        shouldAdd &&
        curColors.some((color: string) => colorsToSearch.includes(color));
    }

    // Cost filter
    if (filters.cost.size !== 0) {
      const curCost = String(card.energy_cost);
      shouldAdd = shouldAdd && filters.cost.has(curCost);
    }

    // Power Cost filter
    if (filters.powerCost.size !== 0) {
      const curPowerCost = String(card.power_cost);
      shouldAdd = shouldAdd && filters.powerCost.has(curPowerCost);
    }

    // Power filter
    if (filters.might.size !== 0) {
      let curPower = String(card.might);
      if (curPower === "-") {
        curPower = "0";
      }
      shouldAdd = shouldAdd && filters.might.has(curPower);
    }

    // Card type filter
    if (filters.cardType.size !== 0) {
      shouldAdd = shouldAdd && filters.cardType.has(card.card_type);
    }

    // Format filter
    if (filters.format.size !== 0) {
      // Add format filtering logic here if needed
      // For now, we'll skip this as it's not implemented in the interface
    }

    if (shouldAdd) {
      filteredCards.push(card);
    }
  }

  return filteredCards;
}
